import * as React from 'react';
export const TDSvg = React.forwardRef(function TDSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M2.005 2A2.008 2.008 0 0 0 0 4.009v7.982C0 13.101.894 14 2.005 14H5V2H2.005Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M11 2v12h2.995A2.008 2.008 0 0 0 16 11.991V4.01C16 2.899 15.106 2 13.995 2H11Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M5 2h6v12H5z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M5 14v-1h6v1H5ZM5 2h6v1H5V2Z',
      }),
    ),
  );
});
TDSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TD = {
  category: 'flag',
  colorable: false,
  name: 'TD',
  svg: TDSvg,
};
